/**
 * External dependencies
 */
import { createSelector } from 'reselect';
import { get, find, map, sortBy, reverse } from 'lodash';

/**
 * Internal dependencies
 */
import { getAllCoupons } from 'state/coupons/selectors';
import { getAllAddons } from 'state/addons/selectors';

export const getCurrentBarcodeLookupId = (state) => get(state, ['currentBarcodeLookup', 'items']);

export const getCurrentBarcodeLookup = (state) => {
    return get(state, ['currentBarcodeLookup', 'items'], []);
};

export const requestingCurrentBarcodeLookup = (state) => get(state, ['currentBarcodeLookup', 'requesting'], false);

export const errorRequestingCurrentBarcodeLookup = (state) => get(state, ['currentBarcodeLookup', 'error'], false);

export const hasScheduledChanges = createSelector(
    getCurrentBarcodeLookup,
    (currentBarcodeLookup) => {
        return get(currentBarcodeLookup, ['has_scheduled_changes'], false);
    },
);
export const getCurrentBarcodeLookupPlanId = createSelector(
    getCurrentBarcodeLookup,
    (currentBarcodeLookup) => {
        return get(currentBarcodeLookup, ['plan_id'], null);
    },
);